import "./style.css";
import Icon from "../Icon";
import MyPopup from "../MyPopup";

export type Alignment = "left" | "center" | "right";

type IconName = "LeftAlign" | "CenterAlign" | "RightAlign" | "DownArrow";

const OPTIONS: { key: Alignment; iconName: IconName; label: string }[] = [
  { key: "left", iconName: "LeftAlign", label: "Left align" },
  { key: "center", iconName: "CenterAlign", label: "Center align" },
  { key: "right", iconName: "RightAlign", label: "Right align" },
];

interface Props {
  value?: Alignment;
  onChange?: (next: Alignment) => void;
  className?: string;
}

export default function AlignmentSelect({
  value = "left",
  onChange = () => {},
}: Props) {
  function onSelect(key: Alignment) {
    onChange(key);
  }

  return (
    <div>
      <MyPopup
        trigger={
          <button className="font-option heading tool-bar-button" data-tooltip="Align">
            <Icon
              name={
                OPTIONS?.find((o) => o.key === value)?.iconName || "LeftAlign"
              }
            />
            <Icon name="DownArrow" className="tool-bar-button-icon" />
          </button>
        }>
        {({ close }) => (
          <>
            {OPTIONS.map((opt) => {
              const active = opt.key === value;
              return (
                <button
                  key={opt.key}
                  role="menuitemradio"
                  aria-checked={active}
                  tabIndex={0}
                  className={`alignment-option ${active ? "active" : ""}`}
                  onClick={() => {
                    onSelect(opt.key);
                    close();
                  }}>
                  <div
                    className="option-check"
                    style={{ opacity: active ? 1 : 0 }}
                    aria-hidden>
                    <svg width="16" height="16" viewBox="0 0 24 24">
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <Icon
                    name={opt.iconName}
                    size={20}
                    className="select-option-icon"
                  />
                </button>
              );
            })}
          </>
        )}
      </MyPopup>
    </div>
  );
}
